import ErrorColoredOutlinedSVG from './icon_error_colored_outlined.svg';
import withIconProps from './withIconProps';

export default withIconProps(ErrorColoredOutlinedSVG);
